import { FunctionComponent } from "react";
import CheckIcon from "@heroicons/react/24/outline/CheckIcon";
import classNames from "classnames";

interface CheckboxProps extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  value: boolean;
  setValue: (val: boolean) => void;
}

const Checkbox: FunctionComponent<CheckboxProps> = ({ value, setValue, className, onClick, ...divProps }) => {
  return (
    <div
      {...divProps}
      onClick={() => setValue(!value)}
      className={classNames(className, "w-6 h-6 rounded-md flex cursor-pointer select-none", {
        "bg-gradient-to-r from-main-from to-main-to text-white": value,
        "border-2 border-gray-400": !value,
      })}
    >
      {!value ? null : <CheckIcon strokeWidth={3} className="w-4 h-4 m-auto" />}
    </div>
  );
};

export default Checkbox;
